import { createStyles }     from "@mantine/core";
import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( {
	feedWrapper: {
		// height   : "65vh",
		flex           : "1",
		display        : "flex",
		// alignItems     : "center",
		justifyContent : "start",
		flexDirection  : "column",
		overflow       : "scroll",

		[rooterMediaQuery.mobile]: {
			height: "calc(100vh - 120px)"
		}
	},
	content: {
		textAlign: "center"
	},
	svgIcon: {
		height       : "12rem",
		width        : "12rem",
		marginBottom : "1rem"
	},
	notificationEmptyText: {
		width        : "250px",
		overflowWrap : "break-word",
		wordBreak    : "break-word"
	}
} )
);

